import { createRouter, createWebHistory } from "vue-router";
import store from "../store";
import MateriaisView from "../views/MateriaisView.vue";
import PedidoFormView from "../views/PedidoFormView.vue";
import Login from "../components/Login.vue";
const SelecionarEmpresaView = () =>
  import("../views/SelecionarEmpresaView.vue");

const MaterialFormView = () => import("../views/MaterialFormView.vue");
const PedidosListView = () => import("../views/PedidosListView.vue");
const ImportarPedidosView = () => import("../views/ImportarPedidosView.vue");
const ProdutosView = () => import("../views/ProdutosView.vue");
const RequisicoesView = () => import("../views/RequisicoesView.vue");
const NovoProdutoView = () => import("../views/NovoProdutoView.vue");
const EstoqueView = () => import("../views/EstoqueView.vue");
const ShowProdutoView = () => import("../views/ShowProdutoView.vue");
const EditarProdutoView = () => import("../views/EditarProdutoView.vue");
const ShowPedidoView = () => import("../views/ShowPedidoView.vue");
const ShowMaterialView = () => import("../views/ShowMaterialView.vue");
const FornecedoresView = () => import("../views/FornecedoresView.vue");
const TiposMateriaisView = () => import("../views/TiposMateriaisView.vue");
const VariacoesMateriaisView = () =>
  import("../views/VariacoesMateriaisView.vue");
const ClientesView = () => import("../views/ClientesView.vue");
const ColaboradoresView = () => import("../views/ColaboradoresView.vue");
const UsuariosView = () => import("../views/UsuariosView.vue");
const RelatoriosView = () => import("../views/RelatoriosView.vue");
const FretesView = () => import("../views/FretesView.vue");
const FinanceiroView = () => import("../views/FinanceiroView.vue");
const CoresView = () => import("../views/CoresView.vue");
const ConfiguracaoEmpresaView = () =>
  import("../views/ConfiguracaoEmpresaView.vue");
const GerenciamentoSistemaView = () =>
  import("../views/GerenciamentoSistemaView.vue");
const CalculadoraMarketplaceView = () =>
  import("../views/CalculadoraMarketplaceView.vue");
const GaleriaView = () => import("../views/GaleriaView.vue");
const ExpedicaoView = () => import("../views/ExpedicaoView.vue");

const authRequired = { meta: { requiresAuth: true } };

const routes = [
  // Endereços do antigo site público: redirecionam ao login
  { path: "/", redirect: "/login" },
  { path: "/catalogo", redirect: "/login" },
  { path: "/contato", redirect: "/login" },
  {
    path: "/galeria",
    name: "galeria",
    component: GaleriaView,
    ...authRequired,
  },

  // ── Autenticação ──────────────────────────────────────
  { path: "/login", name: "login", component: Login },
  {
    path: "/selecionar-empresa",
    name: "selecionarEmpresa",
    component: SelecionarEmpresaView,
    meta: { requiresAuth: true },
  },

  // ── Área administrativa ───────────────────────────────
  { path: "/admin", redirect: "/pedidos" },
  {
    path: "/materiais",
    name: "materiais",
    component: MateriaisView,
    ...authRequired,
  },
  {
    path: "/materiais/novo",
    name: "novoMaterial",
    component: MaterialFormView,
    ...authRequired,
  },
  {
    path: "/materiais/:id",
    name: "showMaterial",
    component: ShowMaterialView,
    ...authRequired,
  },
  {
    path: "/materiais/:id/editar",
    name: "editarMaterial",
    component: MaterialFormView,
    ...authRequired,
  },
  {
    path: "/pedidos",
    name: "pedidos",
    component: PedidosListView,
    ...authRequired,
  },
  {
    path: "/pedidos/novo",
    name: "novoPedido",
    component: PedidoFormView,
    ...authRequired,
  },
  {
    path: "/pedidos/importar",
    name: "importarPedidos",
    component: ImportarPedidosView,
    ...authRequired,
  },
  {
    path: "/pedidos/:id",
    name: "showPedido",
    component: ShowPedidoView,
    ...authRequired,
  },
  {
    path: "/pedidos/:id/editar",
    name: "editarPedido",
    component: PedidoFormView,
    ...authRequired,
  },
  {
    path: "/expedicao",
    name: "expedicao",
    component: ExpedicaoView,
    ...authRequired,
  },
  {
    path: "/produtos",
    name: "produtos",
    component: ProdutosView,
    ...authRequired,
  },
  {
    path: "/produtos/novo",
    name: "novoProduto",
    component: NovoProdutoView,
    ...authRequired,
  },
  {
    path: "/produtos/:id",
    name: "showProduto",
    component: ShowProdutoView,
    ...authRequired,
  },
  {
    path: "/produtos/:id/editar",
    name: "editarProduto",
    component: EditarProdutoView,
    ...authRequired,
  },
  {
    path: "/requisicoes",
    name: "requisicoes",
    component: RequisicoesView,
    ...authRequired,
  },
  {
    path: "/estoque",
    name: "estoque",
    component: EstoqueView,
    ...authRequired,
  },
  {
    path: "/financeiro",
    name: "financeiro",
    component: FinanceiroView,
    ...authRequired,
  },
  {
    path: "/fornecedores",
    name: "fornecedores",
    component: FornecedoresView,
    ...authRequired,
  },
  {
    path: "/tipos-materiais",
    name: "tiposMateriais",
    component: TiposMateriaisView,
    ...authRequired,
  },
  {
    path: "/clientes",
    name: "clientes",
    component: ClientesView,
    ...authRequired,
  },
  {
    path: "/colaboradores",
    name: "colaboradores",
    component: ColaboradoresView,
    ...authRequired,
  },
  {
    path: "/usuarios",
    name: "usuarios",
    component: UsuariosView,
    ...authRequired,
  },
  {
    path: "/tipos-materiais/:id/variacoes",
    name: "variacoesMateriais",
    component: VariacoesMateriaisView,
    ...authRequired,
  },
  {
    path: "/notificacoes",
    name: "notificacoes",
    component: () => import("../views/NotificacoesView.vue"),
    ...authRequired,
  },
  {
    path: "/agenda",
    name: "agenda",
    component: () => import("../views/AgendaView.vue"),
    ...authRequired,
  },
  {
    path: "/relatorios",
    name: "relatorios",
    component: RelatoriosView,
    ...authRequired,
  },
  {
    path: "/fretes",
    name: "fretes",
    component: FretesView,
    ...authRequired,
  },
  {
    path: "/cores",
    name: "cores",
    component: CoresView,
    ...authRequired,
  },
  {
    path: "/configuracao-empresa",
    name: "configuracaoEmpresa",
    component: ConfiguracaoEmpresaView,
    ...authRequired,
  },
  {
    path: "/calculadora",
    name: "calculadoraMarketplace",
    component: CalculadoraMarketplaceView,
    ...authRequired,
  },
  {
    path: "/sistema",
    name: "sistema",
    component: GerenciamentoSistemaView,
    meta: { requiresAuth: true, requiresSuperAdmin: true },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach((to, _from, next) => {
  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);
  const requiresSuperAdmin = to.matched.some(
    (record) => record.meta.requiresSuperAdmin
  );
  const isAuthenticated = store.getters.isAuthenticated;
  const hasCompany = store.getters.hasCompanySelected;
  const isSuperAdmin = store.getters.isSuperAdmin;

  if (requiresAuth && !isAuthenticated) {
    return next("/login");
  }

  if (requiresSuperAdmin && !isSuperAdmin) {
    return next("/admin");
  }

  if (to.name === "login" && isAuthenticated) {
    if (isSuperAdmin && !hasCompany) return next("/sistema");
    return next(hasCompany ? "/admin" : "/selecionar-empresa");
  }

  if (
    requiresAuth &&
    !hasCompany &&
    to.name !== "selecionarEmpresa" &&
    to.name !== "sistema"
  ) {
    if (isSuperAdmin) return next();
    return next("/selecionar-empresa");
  }

  next();
});

export default router;
